import { useDirection, useProperty, useTranslation } from '@eti/providers';
import illustration from '@eti/assets/illustrations/default/qpass.svg?url'; // eslint-disable-line import/no-unresolved
import pictogram from '@eti/assets/pictograms/default/qpass.svg?url'; // eslint-disable-line import/no-unresolved
import logo from '@eti/assets/logos/product-logos/q-pass-logo.svg?url'; // eslint-disable-line import/no-unresolved
import { analytics } from '@eti/utils';
import { css, cx, mediaQueries } from '@eti/styles';
import { useRef } from 'react';
import { useProductSnowplowTracking } from '../../custom-hooks/useProductSnowplowTracking';
import { UPSELL_TYPES } from '../../common/utils/constants';
import { getPrice, getProduct } from '../../single-choice/utils/singleChoiceTransformer';
import ProductLayout from '../../common/main-layout/ProductLayout';
import SmallCardReadMore from '../../common/components/small-card-layout/SmallCardReadMore';
import { getModal, getPriceProps, getReadMoreLabel, getSingleChoiceProps, getUpsellProps } from '../../common/utils/productCardProps';
import { QPASS } from '../../products';
import getTranslatedTexts from '../../common/text-resolvers/utils/getTranslatedTexts';
import { getProductPictogramId } from '../../common/utils/icon/getProductImageryIds';
import { pictogramStyles } from '../../common/main-layout/header/styles';
import { customHeaderStyle, customIllustrationStyle, smallCardGrid } from './styles';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
const {
  name: PRODUCT_NAME,
  id: PRODUCT_ID
} = QPASS;
const texts = {
  readMoreContent: 'qPassReadMoreModalContent',
  text: 'qPassAbstractSmallCard',
  title: 'qPassTitle',
  persuasion: 'qPassPersuasionContent',
  upSell: 'qPassUpSellText'
};
const logoCss = url => css`
  background-image: url(${url});
  background-repeat: no-repeat;
  background-size: contain;
  display: none;
  height: 48px;
  margin-bottom: 8px;
  margin-inline-start: 40px;
  width: 100px;

  @media ${mediaQueries.small.only} {
    display: grid;
  }
`;
const QPass = _ref => {
  var _order$persuasion$isE, _order$persuasion;
  let {
    form,
    isSelected,
    order,
    sellSpecification,
    productPosition
  } = _ref;
  const {
    t,
    nonDebugT
  } = useTranslation();
  const {
    isRTL
  } = useDirection();
  const {
    text,
    readMoreContent,
    title,
    persuasion,
    upSell
  } = getTranslatedTexts(texts, t);
  const rootElement = useRef(null);
  useProductSnowplowTracking(PRODUCT_NAME, {
    rootElement,
    productPosition
  });
  analytics.useLogMouseFlowTagEffect('Small card');
  const {
    p
  } = useProperty();
  const product = getProduct(PRODUCT_ID, order, 'none');
  if (!product) {
    return null;
  }
  const readMoreLink = t('Products.ReadMore.Link.Label');
  const extraProps = {
    ...getSingleChoiceProps(t, p, nonDebugT),
    readMoreLink
  };
  const priceRaw = getPrice(order);
  const {
    priceLabel,
    price,
    priceSuffix
  } = getPriceProps(t, isSelected, product);
  const productCardModal = getModal((_order$persuasion$isE = (_order$persuasion = order.persuasion) === null || _order$persuasion === void 0 ? void 0 : _order$persuasion.isEnabled) !== null && _order$persuasion$isE !== void 0 ? _order$persuasion$isE : false, '', persuasion !== null && persuasion !== void 0 ? persuasion : '');
  const {
    upSellObject,
    shouldDisplayUpsell = false
  } = getUpsellProps(upSell);
  if (upSellObject) {
    upSellObject.type = UPSELL_TYPES.INCLUDED;
  }
  const readMoreButtonLabel = getReadMoreLabel(t);
  const productData = {
    sellSpecification,
    extraProps,
    description: text,
    form,
    illustrationUrl: illustration,
    isSelected,
    price,
    priceLabel,
    priceRaw,
    priceSuffix,
    productId: PRODUCT_ID,
    productName: PRODUCT_NAME,
    readMoreButtonLabel,
    readMoreContent,
    title,
    travelers: order.travelers,
    productCardModal,
    shouldDisplayUpsell,
    upSell: upSellObject
  };
  return /*#__PURE__*/_jsxs(ProductLayout, {
    className: "singleChoice",
    coreComponentsRenderConfig: ['Illustration', 'Header', 'ReadMore'],
    customGrid: smallCardGrid,
    productData: productData,
    ref: rootElement,
    children: [/*#__PURE__*/_jsx(ProductLayout.Header, {
      customGrid: customHeaderStyle,
      children: /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx("div", {
          className: cx(pictogramStyles(pictogram), 'pictogramQpass'),
          "data-testid": `${PRODUCT_NAME}-pictogram`,
          id: getProductPictogramId(PRODUCT_NAME, isRTL)
        }), /*#__PURE__*/_jsx(ProductLayout.Body, {})]
      })
    }), /*#__PURE__*/_jsx(ProductLayout.Illustration, {
      customGrid: customIllustrationStyle
    }), /*#__PURE__*/_jsx(ProductLayout.ReadMore, {
      override: true,
      children: /*#__PURE__*/_jsx(SmallCardReadMore, {
        children: /*#__PURE__*/_jsx("div", {
          className: logoCss(logo),
          "data-testid": `${PRODUCT_NAME}-pictogram`
        })
      })
    })]
  });
};
export default QPass;